import React, { useState, useEffect, useRef, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../../../api";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../../css/DocumentHistoryResponsive.css";
import { getFilteredDocs } from "../../../utils/approvedContentTabs";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import "react-toastify/dist/ReactToastify.css";
import { TOAST_MESSAGES } from "../../../utils/toastMessages";
import { formatFileType } from "../../../utils/FileType";
import ReactMarkdown from "react-markdown";
import { BsLink45Deg, BsArrowRepeat } from "react-icons/bs";
import { useSelector, useDispatch } from "react-redux";

// Icons
import filterIcon from "../../../assets/Images/Filter.png";
import changeStatusIcon from "../../../assets/icons/changeStatusIcon.png";
import warningIcon from "../../../assets/UserIcons/FileIcon.svg";
import deleteIcon from "../../../assets/UserIcons/DeleteIcon.svg";
import trainIcon from "../../../assets/Images/train_data.png";
import trainDoc from "../../../assets/icons/TrainDoc.png";
import trainText from "../../../assets/icons/TrainText.png";
import trainUrls from "../../../assets/icons/TrainUrl.png";
import trainVideo from "../../../assets/icons/TrainVideo.png";
import trainQA from "../../../assets/icons/TrainQA.png";
import fileIcon from "../../../assets/UserIcons/FileIcon.svg";
import linkIcon from "../../../assets/UserIcons/Website.svg";
import videoIcon from "../../../assets/icons/sboxlink.png";
import crossIcon from "../../../assets/UserIcons/Cancel.svg";
import viewIcon from "../../../assets/UserIcons/ViewIcon.svg";
import downloadIcon from "../../../assets/Images/Download.png";
import folderIcon from "../../../assets/UserIcons/Folder.svg";
import pluseIcon from "../../../assets/UserIcons/AddNewDrive.svg";
import { formatDateToUserTimeZone } from "../../../utils/formatDate";
import { useTableSort } from "../../../hooks/useTableSort";
import { SortableHeader } from "../../../components/SortableHeader";
import { truncate, validateFileName } from "../../../utils/validateFileName";

const SaveDocsFiles = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortOrder, setSortOrder] = useState("desc");
  const [dayFilter, setDayFilter] = useState("");
  const [allApprovedDocs, setAllApprovedDocs] = useState([]);
  const [totalFiles, setTotalFiles] = useState(0);
  const [allApprovedDocs1, setAllApprovedDocs1] = useState([]);
  const [attachedFiles, setAttachedFiles] = useState([]);
  const [showFirstModal, setShowFirstModal] = useState(false);
  //Form Uplaod Documents
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [urlLinks, setUrlLinks] = useState([""]);
  const [videoLinks, setVideoLinks] = useState([""]);
  const [uploadMode, setUploadMode] = useState("Global");
  const [showUploadModeDropdown, setShowUploadModeDropdown] = useState(false);
  const [description, setDescription] = useState("");
  const [dataName, setDataName] = useState("");
  const [isEditingDesc, setIsEditingDesc] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showSummaryModal, setShowSummaryModal] = useState(false);
  const [summaryData, setSummaryData] = useState(null);
  const [summaryDataList, setSummaryDataList] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loadingIndex, setLoadingIndex] = useState(null);
  const [activeUpload, setActiveUpload] = useState("files"); // null | "url" | "video"
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedFileToDelete, setSelectedFileToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const isFullPrivacy = false;
  // Flag to show/hide duplicate modal
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);

  // Array of duplicate files returned by backend
  const [duplicateFiles, setDuplicateFiles] = useState([]);

  // Add these states
  const [showTrainingModal, setShowTrainingModal] = useState(false);
  const [selectedFileToTrain, setSelectedFileToTrain] = useState(null);
  const [isTraining, setIsTraining] = useState(false);

  const [stats, setStats] = useState({
    user_files_active_count: 0,
    user_files_inactive_count: 0,
    uploaded_files_active_count: 0,
    uploaded_files_inactive_count: 0,
  });

  const [isLoading, setIsLoading] = useState(false);

  const getMimeTypeFromExtension = (filename) => {
    const ext = filename.split(".").pop().toLowerCase();
    const mimeMap = {
      pdf: "application/pdf",
      txt: "text/plain",
      doc: "application/msword",
      docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      mp3: "audio/mpeg",
      wav: "audio/wav",
      mp4: "video/mp4",
      avi: "video/x-msvideo",
      mov: "video/quicktime",
      mkv: "video/x-matroska",
    };
    return mimeMap[ext] || "application/octet-stream";
  };

  // ✅ Fetch stats
  const fetchStats = async () => {
    try {
      setIsLoading(true);
      const token = localStorage.getItem("access_token");

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/files/stats`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await response.json();

      if (response.ok) {
        setStats(data.data || {});
      } else {
        // showErrorToast(data.message || "Failed to load document stats");
      }
    } catch (error) {
      console.error("❌ Error fetching stats:", error);
      showErrorToast("Something went wrong while fetching stats");
    } finally {
      setIsLoading(false);
    }
  };

  const dropdownRef = useRef();

  const fileInputRef = useRef(null);

  // Open file chooser
  const handleBoxClick = (item) => {
    if (item.isAddNew && fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const fetchGlobalUserDocs = async () => {
    try {
      const res = await api.get(
        `${process.env.REACT_APP_API_URL}/uploaded-files/global-user-docs`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      setAllApprovedDocs1(res.data);
      // console.log(res.data);
    } catch (error) {
      console.error("❌ Error fetching approved docs:", error);
      // showErrorToast(TOAST_MESSAGES.DOCUMENT_HISTORY.FETCH_FAILED);
    }
  };

  useEffect(() => {
    fetchGlobalUserDocs();
  }, []);

  // Corrected file upload function for multiple files
  // const handleFileChange = async (e) => {
  //   const files = Array.from(e.target.files);
  //   if (!files.length) return;

  //   // Mark files as uploading
  //   const newFiles = files.map((file) => ({ file, status: "uploading" }));
  //   setAttachedFiles((prev) => [...prev, ...newFiles]);

  //   const token =
  //     localStorage.getItem("access_token") ||
  //     sessionStorage.getItem("access_token");

  //   try {
  //     const formData = new FormData();

  //     // Append all files to formData
  //     files.forEach((file) => formData.append("files", file));

  //     const res = await api.post(
  //       `${process.env.REACT_APP_API_URL}/files/upload-multiple`,
  //       formData,
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     // Update status for each uploaded file
  //     const uploadedFileNames = res.data.files.map((f) => f.name);
  //     setAttachedFiles((prev) =>
  //       prev.map((f) =>
  //         uploadedFileNames.includes(f.file.name) ? { ...f, status: "done" } : f
  //       )
  //     );

  //     showSuccessToast("Files uploaded successfully");
  //     fetchUserFiles();
  //   } catch (error) {
  //     console.error("Upload failed:", error);
  //     const errorMsg =
  //       error.response?.data?.message ||
  //       error.message ||
  //       "Server failed, please try again later.";

  //     // Mark all failed files as error
  //     setAttachedFiles((prev) =>
  //       prev.map((f) =>
  //         files.some((file) => file.name === f.file.name)
  //           ? { ...f, status: "error" }
  //           : f
  //       )
  //     );

  //     showErrorToast(`File upload failed: ${errorMsg}`);
  //   }

  //   // Reset file input
  //   e.target.value = "";
  // };

  const handleFileChange = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    // 1️⃣ Validate filenames BEFORE upload (non-blocking)
    let validFiles = [];
    let invalidFiles = [];

    for (const file of files) {
      const { valid, reason } = validateFileName(file.name);

      if (valid) {
        validFiles.push(file);
      } else {
        invalidFiles.push({ name: file.name, reason });
      }
    }

    if (invalidFiles.length > 0) {
      const count = invalidFiles.length;

      // 🧠 Adaptive timing
      const autoCloseTime = count <= 2 ? 2000 : count <= 4 ? 1600 : 1200;

      const gap = autoCloseTime + 150;

      invalidFiles.forEach((f, index) => {
        setTimeout(() => {
          showErrorToast(`${f.reason}${truncate(f.name)}`, {
            autoClose: autoCloseTime,
          });
        }, index * gap);
      });
    }

    if (validFiles.length === 0) {
      e.target.value = "";
      return;
    }

    const newFiles = validFiles.map((file) => ({ file, status: "uploading" }));
    setAttachedFiles((prev) => [...prev, ...newFiles]);

    const token =
      localStorage.getItem("access_token") ||
      sessionStorage.getItem("access_token");

    try {
      const formData = new FormData();
      validFiles.forEach((file) => formData.append("files", file));

      const res = await api.post(
        `${process.env.REACT_APP_API_URL}/files/upload-multiple`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      // Check for duplicates returned by API
      if (res.data.status === "duplicate" && res.data.duplicates?.length > 0) {
        setDuplicateFiles(res.data.duplicates); // set duplicate files state
        setShowDuplicateModal(true); // show modal
      } else {
        // Update status for successfully uploaded files
        const uploadedFileNames = res.data.uploaded_files.map((f) => f.name);
        setAttachedFiles((prev) =>
          prev.map((f) =>
            uploadedFileNames.includes(f.file.name)
              ? { ...f, status: "done" }
              : f,
          ),
        );
        showSuccessToast("Files uploaded successfully");
        fetchUserFiles();
      }
    } catch (error) {
      console.error("Upload failed:", error);
      const errorMsg =
        error.response?.data?.message ||
        error.message ||
        "Server failed, please try again later.";

      setAttachedFiles((prev) =>
        prev.map((f) =>
          validFiles.some((file) => file.name === f.file.name)
            ? { ...f, status: "error" }
            : f,
        ),
      );

      showErrorToast(`File upload failed: ${errorMsg}`);
    }

    e.target.value = "";
  };

  const handleDuplicateYes = async () => {
    const token =
      localStorage.getItem("access_token") ||
      sessionStorage.getItem("access_token");

    try {
      const res = await api.post(
        `${process.env.REACT_APP_API_URL}/files/allow-duplicate`, // API for cloning duplicates
        { duplicates: duplicateFiles },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      showSuccessToast(
        `${res.data.count} duplicate files uploaded successfully`,
      );
      fetchUserFiles();

      // Close modal and reset
      setShowDuplicateModal(false);
      setDuplicateFiles([]);
    } catch (err) {
      console.error("Duplicate upload failed:", err);
      showErrorToast("Failed to upload duplicate files");
    }
  };

  const uploadToBackend = async () => {
    try {
      setIsUploading(true);
      setIsSubmitting(true);
      setShowSummaryModal(false); // Close modal automatically after submit

      const formData = new FormData();

      uploadedFiles.forEach((file) => formData.append("files", file));
      urlLinks.forEach((url) => url.trim() && formData.append("urls", url));
      videoLinks.forEach(
        (yt) => yt.trim() && formData.append("youtube_urls", yt),
      );

      const mode =
        uploadMode === "Global" ? "pending_global" : uploadMode.toLowerCase();

      formData.append("upload_mode", mode);
      formData.append("file_description", description);
      formData.append("file_data_name", dataName);

      // Send summaries with each file
      summaryDataList.forEach((item) =>
        formData.append(
          "file_summaries",
          JSON.stringify({
            filename: item.filename,
            summary: item.summary,
            short_description: item.short_description,
          }),
        ),
      );

      const res = await api.post(
        `${process.env.REACT_APP_API_URL}/uploaded-files/upload`,
        formData,
        {
          headers: { Authorization: `Bearer ${token}` },
          onUploadProgress: (progressEvent) => {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total,
            );
            setUploadProgress(percent);
          },
        },
      );

      // console.log("Upload response:", res.data);

      setUploadedFiles([]);
      setUrlLinks([""]);
      setVideoLinks([""]);
      setDescription("");
      setDataName("");
      setShowSummaryModal(false);
      showSuccessToast("Upload successful!");
    } catch (err) {
      console.error("Upload failed:", err);
      showErrorToast("Upload failed!");
    } finally {
      setIsUploading(false);
      setIsSubmitting(false);
      setUploadProgress(0);
    }
  };

  const compactName = (name) => {
    return name.toLowerCase().replace(/[^a-z0-9]/g, "");
  };

  const regenerateSummary = async (index) => {
    if (loadingIndex !== null) return; // prevent multiple clicks
    setLoadingIndex(index);

    try {
      const item = summaryDataList[index];
      // console.log("Item Data", item);
      // console.log("File Data", uploadedFiles);

      const formData = new FormData();

      if (item.type === "file") {
        const file = uploadedFiles.find(
          (f) => compactName(f.name) === compactName(item.filename),
        );

        if (!file) {
          showErrorToast("Original file not available for regeneration");
          return;
        }

        formData.append("files", file);
        formData.append("activeUpload", "files");
      } else if (item.type === "url") {
        formData.append("urls", item.filename); // filename stores URL
        formData.append("activeUpload", "urls");
      } else if (item.type === "video") {
        formData.append("youtube_urls", item.filename);
        formData.append("activeUpload", "videos");
      }

      formData.append("model", "llama-3.3-70b-versatile");

      const response = await api.post(
        `${process.env.REACT_APP_API_URL}/uploaded-files/generate-summary`,
        formData,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      if (response.data?.results && response.data.results.length > 0) {
        const updated = response.data.results[0];

        setSummaryDataList((prev) => {
          const newList = [...prev];
          newList[index] = {
            ...newList[index],
            summary: updated.summary || "No summary available",
            short_description: updated.short_description || "",
            filename: updated.filename || newList[index].filename,
            type: updated.source || newList[index].type,
          };
          return newList;
        });

        showSuccessToast("Summary regenerated successfully!");
      } else {
        showErrorToast("Failed to regenerate summary");
      }
    } catch (err) {
      console.error("Regenerate summary error:", err);
      showErrorToast("Error regenerating summary");
    } finally {
      setLoadingIndex(null);
    }
  };

  const statsData = [
    // {
    //   label: "New",
    //   icon: pluseIcon,
    //   isAddNew: true,
    // },
    // {
    //   label: "Uploaded Documents",
    //   icon: folderIcon,
    //   count:  getFilteredDocs(allApprovedDocs1, "document").length,
    // },
    {
      label: "Saved Documents",
      icon: folderIcon,
      count: stats.user_files_active_count,
    },
    {
      label: "Deleted Documents",
      icon: folderIcon,
      count: stats.user_files_inactive_count || 0,
    },
  ];

  const navigate = useNavigate();
  const location = useLocation();
  const currentTab = location.pathname;

  const tabs = [
    // { name: "Recently", path: "/user/mydrive-recent" },
    // { name: "Uploaded", path: "/user/mydrive-docs" },
    { name: "Saved", path: "/user/personal-space" },
    { name: "Deleted", path: "/user/knowledgespace-deleted" },
    // { name: "Q&A", path: "/user/qahistory" },
  ];

  const token =
    localStorage.getItem("access_token") ||
    sessionStorage.getItem("access_token");

  const fetchUserFiles = useCallback(async (opts = {}) => {
    try {
      const res = await api.get(`${process.env.REACT_APP_API_URL}/files/get`, {
        params: {
          page: opts.page ?? currentPage,
          limit: opts.limit ?? entriesPerPage,
          search: opts.search ?? searchTerm,
          dayFilter: opts.dayFilter ?? dayFilter,
          sortOrder: opts.sortOrder ?? sortOrder,
          itemType: "file",
        },
        headers: { Authorization: `Bearer ${token}` },
      });

      const { folders, files } = res.data.data;
      //   setUserFolders(folders || []);
      const nextFiles = files || [];
      setAllApprovedDocs(nextFiles);
      const headerTotal = Number(res.headers?.["x-total-count"]);
      setTotalFiles(Number.isFinite(headerTotal) ? headerTotal : nextFiles.length);
      // console.log("✅ Files:", res.data);
    } catch (error) {
      console.error("❌ Fetch error:", error);
    }
  }, [
    currentPage,
    entriesPerPage,
    searchTerm,
    dayFilter,
    sortOrder,
    token,
  ]);

  useEffect(() => {
    fetchStats();
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, dayFilter, sortOrder]);

  useEffect(() => {
    const maxPage = Math.max(1, Math.ceil(totalFiles / entriesPerPage));
    if (currentPage > maxPage) setCurrentPage(maxPage);
  }, [totalFiles, entriesPerPage, currentPage]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      fetchUserFiles().catch((err) => console.error("fetchUserFiles crash:", err));
    }, 250);

    return () => clearTimeout(timeout);
  }, [fetchUserFiles]);

  const totalEntries = totalFiles;
  const totalPages = Math.max(1, Math.ceil(totalEntries / entriesPerPage));
  const currentData = allApprovedDocs;
  const showingFrom =
    totalEntries === 0 ? 0 : (currentPage - 1) * entriesPerPage + 1;
  const showingTo = Math.min(currentPage * entriesPerPage, totalEntries);
  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

  // console.log(currentData);
  const handleEntriesChange = (e) => {
    setEntriesPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handlePageClick = (pageNum) => {
    if (pageNum < 1 || pageNum > totalPages) return;
    setCurrentPage(pageNum);
  };

  const handleReset = () => {
    setSortOrder("desc");
    setDayFilter("");
    setSearchTerm("");
    setCurrentPage(1);
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  const handleUploadSelected = async (file) => {
    try {
      if (isSubmitting) return;

      setIsUploading(true);
      setIsSubmitting(true);

      const formData = new FormData();
      formData.append("activeUpload", "files");

      // 🟢 Fetch file blob from the table reference
      const response = await fetch(
        file.file_url || file.user_files_path || file.path,
      );
      if (!response.ok) throw new Error("Failed to fetch file blob");
      const blob = await response.blob();

      const selectedFile = new File([blob], file.name, {
        type: file.file_type || blob.type || "application/octet-stream",
      });

      formData.append("files", selectedFile);
      formData.append("model", "llama-3.3-70b-versatile");

      // ✅ Call the same endpoint as handleSubmit
      const res = await api.post(
        `${process.env.REACT_APP_API_URL}/uploaded-files/generate-summary`,
        formData,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      if (res.data?.results) {
        const mappedSummaries = res.data.results.map((item) => {
          const filename =
            item.filename ||
            (item.chunks && item.chunks.length > 0
              ? item.chunks[0].filename
              : "Untitled");

          return {
            filename,
            summary: item.summary,
            short_description: item.short_description,
            type: item.source,
            approval_request_id: item.approval_request_id || null,
          };
        });

        setSummaryDataList(mappedSummaries);
        setShowSummaryModal(true); // ✅ Open summary modal
      }

      // ✅ After generating summary, mark the original file inactive in DB
      await api.put(
        `${process.env.REACT_APP_API_URL}/files/mark-inactive/${file.user_files_id}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } },
      );
      // console.log(`🟢 Marked file ${file.user_files_id} as inactive.`);

      showSuccessToast(`${file.name} processed successfully!`);
    } catch (err) {
      console.error("❌ Upload/summary failed:", err);
      showErrorToast("Processing failed!");
    } finally {
      setIsUploading(false);
      setIsSubmitting(false);
      setUploadProgress(0);
    }
  };

  const handleDeleteDocument = async (fileId) => {
    setIsDeleting(true);

    try {
      const token = localStorage.getItem("access_token");

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/files/mark-inactive/${fileId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await response.json();

      if (response.ok) {
        // ✅ Refresh file list and close modal
        await fetchUserFiles();
        setShowDeleteModal(false);
        fetchStats();
      } else {
        // ❌ Handle backend response errors
        showErrorToast(data.message || "Failed to delete file");
      }
    } catch (error) {
      console.error("❌ Delete error:", error);
      showErrorToast("Something went wrong while deleting the file.");
    } finally {
      setIsDeleting(false);
    }
  };

  const handleDownload = async (fileId) => {
    const token = localStorage.getItem("access_token");

    try {
      const response = await api.get(
        `${process.env.REACT_APP_API_URL}/files/download`,
        {
          params: { user_files_id: fileId },
          responseType: "blob", // required for file download
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      // 3️⃣ Process and trigger download (same logic)
      const blob = response.data;
      const contentDisposition = response.headers["content-disposition"];
      const filenameMatch = contentDisposition?.match(/filename="?([^"]+)"?/);
      const filename = filenameMatch ? filenameMatch[1] : "downloaded_file";

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      showSuccessToast("File downloaded successfully!");
    } catch (error) {
      console.error("❌ Download error:", error);
      showErrorToast("Failed to download file. Please try again.");
    }
  };

  const formatToastMessage = (message, fileName) => {
    if (!fileName) return message;

    // If backend already included the filename
    if (message.includes(fileName)) {
      return message.replace(fileName, truncate(fileName));
    }

    // Otherwise, append it
    return `${message} ${truncate(fileName)}`;
  };

  const runBackendToasts = (toasts = [], fallbackMessage, fileName) => {
    // ---- fallback ----
    if (!toasts.length) {
      if (fallbackMessage) {
        showErrorToast(formatToastMessage(fallbackMessage, fileName));
      }
      return;
    }

    const count = toasts.length;
    const autoCloseTime = count <= 2 ? 2200 : count <= 4 ? 1800 : 1400;
    const gap = autoCloseTime + 150;

    // ---- backend toasts ----
    toasts.forEach((toast, index) => {
      setTimeout(() => {
        const options = {
          autoClose: autoCloseTime,
          toastId: `training-${index}-${toast.message}`,
        };

        const message = formatToastMessage(toast.message, fileName);

        if (toast.type === "success") {
          showSuccessToast(message, options);
        } else {
          showErrorToast(message, options);
        }
      }, index * gap);
    });
  };

  const handleSendForTraining = async (fileId, mode) => {
    try {
      setShowTrainingModal(false);

      const fileToTrain = allApprovedDocs.find(
        (f) => f.user_files_id === fileId,
      );
      if (!fileToTrain) return showErrorToast("File not found for training.");

      // Fetch file from server
      const fileUrl = `${process.env.REACT_APP_SERVER_URL}/${fileToTrain.user_files_path}`;
      const fileResponse = await fetch(fileUrl);
      if (!fileResponse.ok) throw new Error("Failed to fetch file");

      const blob = await fileResponse.blob();
      const mimeType = getMimeTypeFromExtension(fileToTrain.name);

      const safeFilename =
        fileToTrain.original_filename || fileToTrain.name || "unknown_file.txt";

      const file = new File([blob], safeFilename, { type: mimeType });

      const formData = new FormData();
      formData.append("files", file);
      formData.append("mode", mode.toLowerCase());
      formData.append("model", "llama-3.3-70b-versatile");

      const token = localStorage.getItem("access_token");

      const uploadUrl = `${process.env.REACT_APP_API_URL}/uploaded-files/newQueryUpload`;

      const response = await api.post(uploadUrl, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
        validateStatus: () => true, // <-- important: allows 207 response handling
      });

      // 🔔 backend driven toasts
      const { toasts = [] } = response.data || {};
      runBackendToasts(
        response.data?.toasts,
        response.data?.status === "error" ? response.data?.message : null,
        fileToTrain?.name,
      );

      const apiStatus = response.data?.status;

      // ---------------- BUSINESS LOGIC ----------------
      if (response.status === 200 || response.status === 207) {
        const uploadedFile = response.data?.uploaded_files?.[0];

        const shouldDelete =
          uploadedFile?.upload_status === "success" ||
          apiStatus === "duplicate";

        if (shouldDelete) {
          setAllApprovedDocs((prev) =>
            prev.filter((doc) => doc.user_files_id !== fileId),
          );

          await handleDeleteDocument(fileId);
          navigate("/user/knowledge-repository");
          return;
        }

        return;
      }

      // 207 → duplicate / partial handled only by toasts
      // if (response.status === 207) return;

      // other errors already toasted by backend
    } catch (error) {
      console.error("🔥 Training Error:", error);

      showErrorToast(
        error.response?.data?.message ||
          error.message ||
          "Training failed unexpectedly.",
      );
    } finally {
      setIsTraining(false);
      setShowTrainingModal(false);
      setShowFirstModal(false);
    }
  };

  const openUserFile = (file) => {
    // console.log("=== openUserFile called ===");

    if (!file) {
      console.error("❌ File object missing");
      return;
    }

    // Log the full backend response
    // console.log("Full file object from backend:", file);

    // Safely get filename and file path
    const filename = file.name;
    const filePath = file.user_files_path; // absolute path from backend
    // console.log("Filename extracted:", filename);
    // console.log("File path from backend:", filePath);

    if (!filename || !filePath) {
      console.error("❌ File name or path is missing");
      showErrorToast("File name or path is missing");
      return;
    }

    // Get file extension
    const ext = filename.split(".").pop().toLowerCase();
    // console.log("File extension:", ext);

    // Construct file URL: documents use API endpoint, audio/video use direct path
    const isMedia = [
      "mp3",
      "wav",
      "aac",
      "mp4",
      "mov",
      "avi",
      "mkv",
      "webm",
    ].includes(ext);
    const fileUrl = isMedia
      ? `${process.env.REACT_APP_SERVER_URL}/${filePath.replace(/\\/g, "/")}` // convert backslashes to slashes
      : `${process.env.REACT_APP_API_URL}/files/view-file?user_files_id=${
          file.user_files_id || file.id
        }`;
    // console.log("File URL to open:", fileUrl);

    // Define file type arrays
    const documentExt = [
      "pdf",
      "doc",
      "docx",
      "xls",
      "xlsx",
      "ppt",
      "pptx",
      "txt",
      "csv",
      "bmp",
      "tiff",
    ];
    const audioExt = ["mp3", "wav", "aac", "flac", "flv"];
    const videoExt = ["mp4", "mov", "avi", "mkv", "webm"];

    // 📄 Documents
    if (documentExt.includes(ext)) {
      const googleViewUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(
        fileUrl,
      )}&embedded=true`;
      // console.log("Opening document in Google Viewer:", googleViewUrl);
      return window.open(googleViewUrl, "_blank");
    }

    // 🎧 Audio
    if (audioExt.includes(ext)) {
      // console.log("Opening audio in new window");
      const w = window.open("", "_blank");
      w.document.write(`
      <audio controls autoplay style="width:100%;">
        <source src="${fileUrl}">
        Your browser does not support the audio tag.
      </audio>
    `);
      return;
    }

    // 🎥 Video
    if (videoExt.includes(ext)) {
      // console.log("Opening video in new window");
      const videoWindow = window.open("", "_blank");

      const type = `video/${ext === "mp4" ? "mp4" : ext}`; // basic MIME detection
      // console.log("Video MIME type:", type);

      videoWindow.document.write(`
      <html>
        <head>
          <title>${filename}</title>
        </head>
        <body style="margin:0; display:flex; justify-content:center; align-items:center; height:100vh; background:#000;">
          <video controls autoplay style="width:80%; max-height:90vh;">
            <source src="${fileUrl}" type="${type}">
            Your browser does not support the video tag.
          </video>
        </body>
      </html>
    `);
      videoWindow.document.close();
      // console.log("Video window loaded successfully");
      return;
    }

    // ⬇️ Fallback: download/open
    // console.log("File type not recognized, opening file directly:", fileUrl);
    window.open(fileUrl, "_blank");
  };

  const { sortedData, requestSort, sortConfig } = useTableSort(currentData);

  return (
    <div className="mx-2 pt-1 h-100">
      <div className="d-flex flex-wrap gap-3 mb-0 align-items-stretch">
        {/* Hidden file input */}
        <input
          type="file"
          ref={fileInputRef}
          multiple
          accept=".pdf,.docx,.txt,.doc,.pptx,.xlsx,.mp3,.wav,.aac,.flac,.mp4,.mov,.avi,.mkv,.flv,.png,.jpg,.jpeg,.gif,.bmp,.tiff"
          style={{ display: "none" }}
          onChange={handleFileChange}
        />

        {statsData.map((item, index) => (
          <div
            key={index}
            className={`dashboard-box p-3 rounded shadow-sm d-flex flex-column  ${
              item.isAddNew ? "AddNew" : ""
            }`}
            style={{
              cursor: item.isAddNew ? "pointer" : "default",
              transition: "0.2s ease",
            }}
            onClick={() => handleBoxClick(item)}
          >
            {/* Top Section */}
            <div
              style={{
                flexDirection: item.isAddNew ? "column" : "row",
                gap: item.isAddNew ? "19px" : "8px",
              }}
              className={`d-flex align-items-${
                item.isAddNew ? "start" : "center"
              } ${item.isAddNew ? "" : ""}`}
            >
              {item.icon && (
                <img
                  className="icon-image"
                  src={item.icon}
                  alt={item.label}
                  style={{ width: "18px", height: "18px" }}
                />
              )}
              <h6 className="mb-0">{item.label}</h6>
            </div>

            {/* Bottom Section (count for non-AddNew) */}
            {!item.isAddNew ? (
              <div
                className="d-flex ak-text-md  w-100 mt-2 refresh-prompts"
                style={{ fontWeight: "600" }}
              >
                {isLoading ? "0" : (item.count ?? 0)}
              </div>
            ) : (
              <div className="box-summary">
                <span className="invisible">placeholder</span>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="d-flex refresh-prompts justify-content-between align-items-center mb-2 mt-1 ">
        <span className="fw-bold">Saved Documents</span>
      </div>

      <div className="mt-3 tabs-wrapper justify-content-between align-items-center">
        <div className="tab-container">
          {tabs.map((tab) => (
            <button
              key={tab.name}
              className={`tab-button ${
                currentTab === tab.path ? "active" : " "
              }`}
              onClick={() => navigate(tab.path)}
            >
              {tab.name}
            </button>
          ))}
        </div>

        <button
          className="ak-text-md custom-btn p-2 d-flex gap-2 align-items-center"
          onClick={handleButtonClick}
        >
          <img src={pluseIcon} className="icon-image3" />
          <span>New Files</span>
        </button>
      </div>

      {allApprovedDocs?.length === 0 ? (
        <></>
      ) : (
        <div
          style={{ borderLeft: "1px solid var(--dark-color) " }}
          className="d-flex px-2 py-1 justify-content-between align-items-center "
        >
          <div className="d-flex align-items-center">
            <select
              className="form-select w-auto"
              value={entriesPerPage}
              onChange={handleEntriesChange}
            >
              {[50, 100, 500].map((n) => (
                <option key={n} value={n}>
                  {n}
                </option>
              ))}
            </select>
            <label className="ms-2 mt-2">Entries per page</label>
          </div>

          {/* Search input */}
          <div className="search">
            <div
              className="input-group custom-search-group"
              style={{ width: "320px" }}
            >
              <span className="input-group-text">
                <i className="bi bi-search"></i>
              </span>
              <input
                type="text"
                className="form-control"
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
        </div>
      )}
      {totalEntries === 0 ? (
        <div className="text-center my-5">
          <p className="refresh-prompts ak-text-md">
            No documents saved yet. Upload a document to get started.
          </p>
        </div>
      ) : (
        <div
          className="not-disable"
          style={{ borderLeft: "1px solid var(--dark-color) " }}
        >
          <div className="table-responsive">
            <table className="table DocHistory-table table-sm w-100">
              <thead className="text-left">
                <tr>
                  <SortableHeader
                    column="name"
                    label="Name"
                    sortConfig={sortConfig}
                    onSort={requestSort}
                  />

                  <SortableHeader
                    column="file_extension"
                    label="Type"
                    sortConfig={sortConfig}
                    onSort={requestSort}
                  />

                  <SortableHeader
                    column="file_size"
                    label="Size"
                    sortConfig={sortConfig}
                    onSort={requestSort}
                  />

                  <SortableHeader
                    column="created_timestamp"
                    label="Uploaded On"
                    sortConfig={sortConfig}
                    onSort={requestSort}
                  />

                  <SortableHeader
                    column="updated_timestamp"
                    label="Last Updated On"
                    sortConfig={sortConfig}
                    onSort={requestSort}
                  />

                  <th className="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {sortedData.map((file, index) => (
                  <tr key={file.user_files_id || index}>
                    <td title={file.name}>
                      {file.name.replace(/\.[^/.]+$/, "")}
                    </td>
                    <td>{formatFileType(file.file_type, file.name)}</td>
                    <td>{formatFileSize(file.file_size)}</td>

                    <td data-label="First Created" className="text-left">
                      {formatDateToUserTimeZone(file.created_timestamp)}
                    </td>
                    <td data-label="Last Updated" className="text-left">
                      {formatDateToUserTimeZone(file.updated_timestamp)}
                    </td>
                    <td className="text-center">
                      <button
                        className="icon-button"
                        title="Send for Training"
                        onClick={() => {
                          setSelectedFileToTrain(file.user_files_id);
                          // setShowTrainingModal(true);
                          setShowFirstModal(true);
                        }}
                      >
                        <img
                          className="icon-image"
                          src={trainIcon} // use training icon
                          alt="Train"
                        />
                      </button>
                      {/* <button
                        className="icon-button"
                        onClick={() => openUserFile(file)}
                        title="View"
                      >
                        <img src={viewIcon} className="icon-image" alt="View" />
                      </button> */}

                      <button
                        className="icon-button"
                        onClick={() => handleDownload(file.user_files_id)}
                        title="Download  File"
                      >
                        <img
                          className="icon-image"
                          src={downloadIcon}
                          alt="Download File"
                        />
                      </button>

                      <button
                        onClick={() => {
                          setSelectedFileToDelete(file.user_files_id); // store the file ID
                          setShowDeleteModal(true); // open modal
                        }}
                        className="icon-button"
                        title="Delete"
                      >
                        <img
                          className="icon-image"
                          src={deleteIcon}
                          alt="Delete"
                        />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="table-footer bgcolor fixed-bottom-footer d-flex justify-content-between align-items-center">
            <div className="refresh-prompts">
              Showing {showingFrom} to {showingTo} of {totalEntries} entries
            </div>
            <ul className="pagination mb-0">
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageClick(1)}
                >
                  <i className="bi bi-chevron-double-left" />
                </button>
              </li>
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageClick(currentPage - 1)}
                >
                  <i className="bi bi-chevron-left" />
                </button>
              </li>
              {pageNumbers.map((num) => (
                <li
                  key={num}
                  className={`page-item ${currentPage === num ? "active" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(num)}
                  >
                    {num}
                  </button>
                </li>
              ))}
              <li
                className={`page-item ${
                  currentPage === totalPages ? "disabled" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageClick(currentPage + 1)}
                >
                  <i className="bi bi-chevron-right" />
                </button>
              </li>
              <li
                className={`page-item ${
                  currentPage === totalPages ? "disabled" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageClick(totalPages)}
                >
                  <i className="bi bi-chevron-double-right" />
                </button>
              </li>
            </ul>
          </div>
        </div>
      )}

      {showDeleteModal && selectedFileToDelete && (
        <div className="modal modal-backdrop-custom d-block" tabIndex="-1">
          <div className="modal-history modal-dialog-centered history-model">
            <div className="modal-content position-relative">
              {/* Close Button */}
              <button
                type="button"
                className="modal-close-btn position-absolute top-0 end-0 mt-2 me-2"
                onClick={() => {
                  if (!isDeleting) {
                    setShowDeleteModal(false);
                    setSelectedFileToDelete(null);
                  }
                }}
                aria-label="Close"
              >
                <img
                  src={crossIcon}
                  className="icon-image cross-i"
                  alt="Close"
                />
              </button>

              {/* Modal Body */}
              <div className="text-center p-3">
                <div
                  className="mx-auto mb-3 d-flex align-items-center justify-content-center"
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%",
                    backgroundColor: "#f0f0f0",
                    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <img
                    src={deleteIcon} // ← your train icon import
                    alt="Training"
                    style={{ width: "40px", height: "40px" }}
                  />
                </div>

                <p className="fw-bold mt-3 mb-3 refresh-prompts">
                  Are you sure you want to delete this file? <br />
                </p>
              </div>

              {/* Modal Footer */}
              <div className="modal-footer justify-content-center gap-2">
                <button
                  type="button"
                  disabled={isDeleting}
                  className="px-5 rounded cancle-btn border-none py-2 fw-bold"
                  onClick={() => {
                    if (!isDeleting) {
                      setShowDeleteModal(false);
                      setSelectedFileToDelete(null);
                    }
                  }}
                >
                  Cancel
                </button>

                <button
                  type="button"
                  disabled={isDeleting}
                  className="px-5 rounded custom-btn border-none py-2 fw-bold history-btn"
                  onClick={async () => {
                    try {
                      await handleDeleteDocument(selectedFileToDelete);
                      setSelectedFileToDelete(null);
                    } catch (err) {
                      showErrorToast("Error inside modal delete handler");
                    }
                  }}
                >
                  {isDeleting ? "Deleting..." : "Delete"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showSummaryModal && summaryDataList && (
        <div className="modal modal-backdrop-custom d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="document-modal modal-content">
              {/* Modal Header */}
              <div className="modal-header justify-content-center position-relative">
                <h5 className="modal-title m-0">
                  Summaries from uploaded Documents and URL
                </h5>
                <button
                  type="button"
                  className="modal-close-btn"
                  onClick={() => setShowSummaryModal(false)}
                  aria-label="Close"
                >
                  <img
                    src={crossIcon}
                    className="icon-image1 cross-i"
                    alt="Close"
                  />
                </button>
              </div>

              {/* Modal Body */}
              <div
                className="modal-body summary-markdown"
                style={{ maxHeight: "600px", overflowY: "auto" }}
              >
                <div className="row">
                  {/* Data Name */}
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-semibold">Data Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Data Name"
                      value={dataName}
                      onChange={(e) => setDataName(e.target.value)}
                      disabled={isUploading || isSubmitting}
                      style={{
                        pointerEvents: isUploading ? "none" : "auto",
                        opacity: isUploading ? 0.5 : 1,
                      }}
                    />
                  </div>

                  {/* Upload Mode */}
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-semibold">
                      Upload Mode
                    </label>
                    <div className="dropdown" ref={dropdownRef}>
                      <button
                        type="button"
                        onClick={() =>
                          !isUploading &&
                          setShowUploadModeDropdown(!showUploadModeDropdown)
                        }
                        disabled={isUploading || isSubmitting}
                        className="form-control"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          width: "100%",
                          height: "38px",
                          padding: "6px 12px",
                          backgroundColor: "var(--input-bg-color)",
                          color: "var(--input-text-color)",
                          border: "1px solid var(--input-border-color)",
                          borderRadius: "0.375rem",
                          cursor: "pointer",
                          fontSize: "1rem",
                          pointerEvents: isUploading ? "none" : "auto",
                          opacity: isUploading ? 0.5 : 1,
                        }}
                      >
                        <span>{uploadMode}</span>
                        <i
                          className={`bi ${
                            showUploadModeDropdown
                              ? "bi-chevron-up"
                              : "bi-chevron-down"
                          }`}
                          style={{ fontSize: "1rem" }}
                        ></i>
                      </button>

                      {showUploadModeDropdown && (
                        <div className="dropdown-menu show w-25 shadow-sm custom-dropdown">
                          {["Global", "Personal"].map((mode) => (
                            <label
                              key={mode}
                              className="form-check custom-form-check d-flex align-items-center"
                              style={{ cursor: "pointer", width: "100%" }}
                              onClick={() => {
                                setUploadMode(mode);
                                setShowUploadModeDropdown(false);
                              }}
                            >
                              <input
                                className="custom-radio"
                                type="radio"
                                name="uploadMode"
                                value={mode}
                                checked={uploadMode === mode}
                                onChange={() => {}}
                              />
                              <span className="form-check-label custom-label ms-2">
                                {mode}
                              </span>
                            </label>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Summaries */}
                {summaryDataList.length === 0 ? (
                  <p>No summaries available.</p>
                ) : (
                  summaryDataList.map((summary, index) => (
                    <div
                      key={index}
                      className="rounded-3 document-modal-data p-3 mb-3"
                      style={{
                        backgroundColor: "#f8f9fa",
                      }}
                    >
                      {/* Header */}
                      <div className="mb-2 d-flex align-items-center gap-3">
                        {summary.type === "file" ? (
                          <img
                            src={fileIcon}
                            alt="file"
                            className="icon-image1"
                            style={{ width: 20, height: 20 }}
                          />
                        ) : (
                          <img
                            src={linkIcon}
                            alt="link"
                            style={{ width: 20, height: 20 }}
                          />
                        )}
                        <div>
                          <div
                            className="refresh-prompts summary-text text-truncate"
                            title={summary.filename}
                            style={{
                              maxWidth: "400px", // adjust width as needed
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              cursor: "default",
                              fontSize: "16px",
                              fontWeight: "bolder",
                            }}
                          >
                            {summary.filename || "Untitled"}
                          </div>
                        </div>
                      </div>

                      {/* Markdown Content */}
                      <div
                        className="summary-markdown"
                        style={{
                          maxHeight: "200px",
                          overflowY: "auto",
                          padding: "8px",
                          marginBottom: "8px",
                        }}
                      >
                        {summary.summary ? (
                          <ReactMarkdown
                            components={{
                              h1: ({ node, ...props }) => (
                                <h1
                                  style={{
                                    fontSize: "15px",
                                    fontWeight: "bold",
                                  }}
                                  {...props}
                                />
                              ),
                              h2: ({ node, ...props }) => (
                                <h2
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                  }}
                                  {...props}
                                />
                              ),
                              h3: ({ node, ...props }) => (
                                <h3
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                  }}
                                  {...props}
                                />
                              ),
                              p: ({ node, ...props }) => (
                                <p
                                  style={{ margin: "4px 0", fontSize: "small" }}
                                  {...props}
                                />
                              ),
                              li: ({ node, ...props }) => (
                                <li
                                  style={{
                                    marginBottom: "4px",
                                    fontSize: "small",
                                  }}
                                  {...props}
                                />
                              ),
                            }}
                          >
                            {summary.summary}
                          </ReactMarkdown>
                        ) : (
                          "No summary available."
                        )}
                      </div>

                      {/* Regenerate Button */}
                      <div className="d-flex regenerate-btn justify-content-end">
                        <button
                          className="btn btn-link text-white bg-dark"
                          onClick={() => regenerateSummary(index)}
                          disabled={loadingIndex === index}
                        >
                          {loadingIndex === index ? (
                            <span className="spinner-border spinner-border-sm text-light" />
                          ) : (
                            <BsArrowRepeat size={18} />
                          )}
                        </button>
                      </div>
                    </div>
                  ))
                )}
              </div>

              {/* Modal Footer */}
              <div className="d-flex justify-content-center mb-3 gap-3">
                <button
                  type="button"
                  className="custom-btn w-25"
                  onClick={uploadToBackend}
                  disabled={isUploading || isSubmitting}
                >
                  {isUploading ? "Uploading..." : "Submit"}
                </button>
                <button
                  type="button"
                  className="cancle-btn1 w-25"
                  onClick={() => {
                    // Close modal
                    setShowSummaryModal(false);

                    // Clear selections
                    setUploadedFiles([]);
                    setUrlLinks([]);
                    setVideoLinks([]);

                    // Reset active upload if needed
                    setActiveUpload("files");
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showFirstModal && (
        <div className="modal modal-backdrop-custom d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="document-modal modal-content text-center">
              {/* Header */}
              <div className="modal-header justify-content-center position-relative">
                <button
                  type="button"
                  className="btn position-absolute "
                  aria-label="Close"
                  style={{
                    top: "10px",
                    right: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 9999,
                    padding: 0,
                    border: "none",
                  }}
                >
                  <img
                    src={crossIcon}
                    alt="Close"
                    onClick={() => setShowFirstModal(false)} // click only triggers when image is clicked
                    style={{
                      width: "20px",
                      height: "20px",
                    }}
                    className="icon-image"
                  />
                </button>
              </div>

              {/* Body */}
              <div className="modal-body" style={{ padding: "20px" }}>
                {/* ✅ Centered Icon */}
                <div className="d-flex justify-content-center align-items-center mb-3">
                  <div
                    className="rounded-circle d-flex justify-content-center align-items-center p-3"
                    style={{
                      width: "60px",
                      height: "60px",
                      backgroundColor: "#E3E6EA",
                    }}
                  >
                    <img
                      src={fileIcon}
                      alt="Upload"
                      style={{ maxWidth: "30px", maxHeight: "30px" }}
                      className="icon-image1"
                    />
                  </div>
                </div>

                <p className="refresh-prompts">
                  You have uploaded document. You are currently in{" "}
                  <>{uploadMode} Mode</>.
                </p>

                <p className="refresh-prompts">
                  You can change the mode below if needed:
                </p>

                <div className="d-flex justify-content-center md:gap-4 my-3">
                  {["Global", "Personal"].map((mode) => (
                    <label
                      key={mode}
                      className="form-check custom-form-check d-flex align-items-center gap-2 pl-0 p-2"
                      style={{ cursor: "pointer" }}
                    >
                      <input
                        type="radio"
                        name="mode"
                        className="custom-radio"
                        value={mode}
                        checked={uploadMode === mode}
                        onChange={() => setUploadMode(mode)}
                      />
                      <span className="refresh-prompts">{mode}</span>
                    </label>
                  ))}
                </div>
              </div>

              {/* Footer */}
              <div className="modal-footer justify-content-center mb-3 gap-3">
                <button
                  className="cancle-btn w-25"
                  onClick={() => setShowFirstModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="custom-btn w-25"
                  onClick={() => {
                    setShowTrainingModal(true);
                    setShowFirstModal(false);
                  }}
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showTrainingModal && selectedFileToTrain && (
        <div className="modal modal-backdrop-custom d-block" tabIndex="-1">
          <div className="modal-history modal-dialog-centered history-model">
            <div className="modal-content position-relative">
              {/* Close Button */}
              <button
                type="button"
                className="modal-close-btn position-absolute top-0 end-0 mt-2 me-2"
                onClick={() => {
                  if (!isTraining) {
                    setShowTrainingModal(false);
                    setSelectedFileToTrain(null);
                  }
                }}
                aria-label="Close"
              >
                <img
                  src={crossIcon}
                  className="icon-image cross-i"
                  alt="Close"
                />
              </button>

              {/* Modal Body */}
              <div className="text-center p-4">
                {/* 🔹 Train Icon in Circle */}
                <div
                  className="mx-auto mb-3 d-flex align-items-center justify-content-center"
                  style={{
                    width: "80px",
                    height: "80px",
                    borderRadius: "50%",
                    backgroundColor: "#f0f0f0",
                    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <img
                    src={trainIcon} // ← your train icon import
                    alt="Training"
                    style={{ width: "40px", height: "40px" }}
                  />
                </div>

                {/* Text */}
                <p className="fw-bold mt-3 mb-3 refresh-prompts">
                  Are you sure you want to send this document for training?
                </p>
              </div>

              {/* Modal Footer */}
              <div className="modal-footer justify-content-center gap-2">
                <button
                  type="button"
                  disabled={isTraining}
                  className="px-5 rounded cancle-btn border-none py-2 fw-bold"
                  onClick={() => {
                    if (!isTraining) {
                      setShowTrainingModal(false);
                      setSelectedFileToTrain(null);
                    }
                  }}
                >
                  Cancel
                </button>

                <button
                  type="button"
                  disabled={isTraining}
                  className="px-5 rounded custom-btn border-none py-2 fw-bold history-btn"
                  onClick={async () => {
                    try {
                      await handleSendForTraining(
                        selectedFileToTrain,
                        uploadMode,
                      );
                      setSelectedFileToTrain(null);
                    } catch (err) {
                      showErrorToast(
                        "Error while sending document for training",
                      );
                    }
                  }}
                >
                  {/* {isTraining ? "Sending..." : "Send"} */}
                  Send
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showDuplicateModal && (
        <div className="modal modal-backdrop-custom d-block" tabIndex="-1">
          <div className="modal-history modal-dialog-centered history-model">
            <div className="modal-content w-50 position-relative">
              <button
                type="button"
                className="modal-close-btn position-absolute top-0 end-0 mt-2 me-2"
                onClick={() => {
                  setShowDuplicateModal(false);
                  setDuplicateFiles([]);
                }}
              >
                <img
                  src={crossIcon}
                  className="icon-image cross-i"
                  alt="Close"
                />
              </button>

              <div className="text-center p-3">
                <div
                  className="mx-auto mb-3 d-flex align-items-center justify-content-center"
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%",
                    backgroundColor: "#f0f0f0",
                    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <img
                    src={warningIcon}
                    alt="Duplicate Files"
                    style={{ width: "40px", height: "40px" }}
                  />
                </div>

                <p className="fw-bold mt-3 mb-3 refresh-prompts">
                  Duplicate files detected. Do you want to upload anyway?
                </p>

                <div style={{ maxHeight: "150px", overflowY: "auto" }}>
                  {duplicateFiles.map((f) => (
                    <p key={f.file_hash} className="mb-1">
                      📄 <b>{f.originalname}</b> ({Math.round(f.size / 1024)}{" "}
                      KB)
                    </p>
                  ))}
                </div>
              </div>

              <div className="modal-footer justify-content-center gap-2">
                <button
                  type="button"
                  className="px-5 rounded cancle-btn border-none py-2 fw-bold"
                  onClick={() => {
                    setShowDuplicateModal(false);
                    setDuplicateFiles([]);
                    showErrorToast("Upload cancelled");
                  }}
                >
                  No
                </button>

                <button
                  type="button"
                  className="px-5 rounded custom-btn border-none py-2 fw-bold history-btn"
                  onClick={handleDuplicateYes}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SaveDocsFiles;
